import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  _getRoute,
  _createRoute,
  _updateRoute,
  _updateRouteStatus,
  _getRouteCategory,
  getRouteRequest,
  createRouteRequest,
  updateRouteRequest,
  updateRouteStatusRequest,
  getIssuerRouteRequest
} from 'src/api/RouteManagerRequest';
import { GETROUTE_SUCCESS, GETROUTE_CATEGORY_SUCCESS } from '../types';
import { checkRequestError } from '.';
import { requestWrapper } from 'src/utils/utils';

export const getRoutes = (filterObj, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile?.super == 1
          ? await getRouteRequest(filterObj)
          : await getIssuerRouteRequest(filterObj);
      checkRequestError(data);

      dispatch({
        type: GETROUTE_SUCCESS,
        payload: data.content.data?.all || []
      });

      return 1;
    } catch (error) {
      console.log('error here', error);
      // NotificationManager.info(error.message, 'Info');
      return -1;
    }
  };
};

// v1 deprecated
export const getRouteCategory = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getRouteCategory();

      if (data.error.status == 1) {
        // NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETROUTE_CATEGORY_SUCCESS, payload: data.content });
        // NotificationManager.success("API Code", 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      // NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const createRoute = (payload, profile) => {
  return async (dispatch) => {
    try {
      const { data } = await createRouteRequest(requestWrapper(payload));
      checkRequestError(data);

      dispatch(getRoutes());

      NotificationManager.success('Route created successfully', 'Success');
      dispatch(getRoutes('_', profile));
      return 1;
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const updateRoute = (id, payload) => {
  return async (dispatch) => {
    try {
      const { data } = await updateRouteRequest(id, requestWrapper(payload));

      checkRequestError(data);

      dispatch(getRoutes());
      NotificationManager.success('Route updated successfully', 'Success');
      return 1;
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const updateRouteStatus = (id, payload, profile) => {
  return async (dispatch) => {
    try {
      const { data } = await updateRouteStatusRequest(
        id,
        requestWrapper(payload)
      );
      checkRequestError(data);

      dispatch(getRoutes({}, profile));
      NotificationManager.success('Route status updated.', 'Success');
      return 1;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};
